/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Total_RevenueInputs */

const en_total_revenue = /** @type {(inputs: Total_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Revenue`)
};

const es_total_revenue = /** @type {(inputs: Total_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingresos totales`)
};

const fr_total_revenue = /** @type {(inputs: Total_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revenus totaux`)
};

const de_total_revenue = /** @type {(inputs: Total_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesamtumsatz`)
};

const ja_total_revenue = /** @type {(inputs: Total_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`総収益`)
};

const zh_total_revenue = /** @type {(inputs: Total_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`总收入`)
};

const ar_total_revenue = /** @type {(inputs: Total_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إجمالي الإيرادات`)
};

const id_total_revenue = /** @type {(inputs: Total_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Pendapatan`)
};

const it_total_revenue = /** @type {(inputs: Total_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrate Totali`)
};

const ru_total_revenue = /** @type {(inputs: Total_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Общая выручка`)
};

const pt_total_revenue = /** @type {(inputs: Total_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Receita Total`)
};

const ko_total_revenue = /** @type {(inputs: Total_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`총 수익`)
};

/**
* | output |
* | --- |
* | "Total Revenue" |
*
* @param {Total_RevenueInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const total_revenue = /** @type {((inputs?: Total_RevenueInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Total_RevenueInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_total_revenue(inputs)
	if (locale === "es") return es_total_revenue(inputs)
	if (locale === "fr") return fr_total_revenue(inputs)
	if (locale === "de") return de_total_revenue(inputs)
	if (locale === "ja") return ja_total_revenue(inputs)
	if (locale === "zh") return zh_total_revenue(inputs)
	if (locale === "ar") return ar_total_revenue(inputs)
	if (locale === "id") return id_total_revenue(inputs)
	if (locale === "it") return it_total_revenue(inputs)
	if (locale === "ru") return ru_total_revenue(inputs)
	if (locale === "pt") return pt_total_revenue(inputs)
	return ko_total_revenue(inputs)
});